

let arr = []
let children = []
let children2 = []
let children3 = []
for( let i = 0 ; i < 31; i ++){
    let m = i + 1
    let obj = {
        value: `${ m < 10 ? '0' + m: m}`,
        label: `${i + 1}日`
    }
    children.push(obj)
}
for( let i = 0 ; i < 29; i ++){
    let m = i + 1
    let obj = {
        value: `${ m < 10 ? '0' + m: m}`,
        label: `${i + 1}日`
    }
    children2.push(obj)
}
for( let i = 0 ; i < 30; i ++){
    let m = i + 1
    let obj = {
        value: `${ m < 10 ? '0' + m: m}`,
        label: `${i + 1}日`
    }
    children3.push(obj)
}
for( let i = 0 ; i < 12; i ++){
    let m = i + 1
    let obj = {
        value: `${ m < 10 ? '0' + m: m}`,
        label: `${m}月`
    }
    // 1 3 5 7 8 10 12 
    if (m == 1 || m == 3 || m == 5 || m == 7 || m == 8 || m == 10 || m == 12) {
        obj.children = children
    }else if( m == 2){
        obj.children = children2
    }else{
        obj.children = children3
    }
    // 2


    arr.push(obj)
}


export default arr